export default {
  projectDetail: {},
  checkBdUser: [],
  groupDetail: {},
  dishesMatchDetail: {
    recordInfo: {},
  },
  basicInfo: {},
}
